import { BdsButton, BdsGrid, BdsIllustration, BdsPaper, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { Analytics } from 'infra/adapters';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { NUMBER_PREPARATION } from 'constants/Routes';

export const ActiveMessagesWhatsappInactive = () => {
  const navigate = useNavigate();

  const handleActivateWhatsapp = () => {
    Analytics.Track(Analytics.events.ACTIVE_MESSAGES_ACTIVATE_WHATSAPP);
    navigate(NUMBER_PREPARATION);
  };

  return (
    <>
      <BdsPaper style={{ background: '#FFF' }}>
        <BdsGrid
          direction="column"
          justifyContent="center"
          alignItems="center"
          padding="5"
          gap="3"
          style={{ width: '100%' }}
        >
          <BdsGrid alignItems="center" gap="2">
            <BdsIllustration className="active-messages-whatsapp-inactive-ilustrator" name="agent-1" type="default" />
          </BdsGrid>
          <BdsGrid alignItems="center" gap="2">
            <BdsTypo variant="fs-20" margin={false} bold="bold">
              Ative o WhatsApp para começar
            </BdsTypo>
          </BdsGrid>
          <BdsGrid alignItems="center" gap="2">
            <BdsTypo
              className="active-messages-whatsapp-inactive-text-activate"
              variant="fs-16"
              margin={false}
              bold="regular"
            >
              Para criar e enviar mensagens ativas, primeiro é necessário ativar o WhatsApp na sua conta.
            </BdsTypo>
          </BdsGrid>
          <BdsGrid alignItems="center" gap="2">
            <BdsButton
              onBdsClick={() => handleActivateWhatsapp()}
              variant="outline"
              color="primary"
              data-testid="button-activate-whatsapp"
            >
              Ativar WhatsApp
            </BdsButton>
          </BdsGrid>
        </BdsGrid>
      </BdsPaper>
    </>
  );
};
